import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500 md:text-sm" aria-label="面包屑">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-800">{item.label}</span>
          )}
          {index < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-sm text-foreground-400" />
          )}
        </span>
      ))}
    </nav>
  );
}